import { Role } from '@tools/ui/types/generated/graphql';
import { openToast } from './toast.util';
import { t } from './translate.util';

export type Response = {
  error?: string;
  message?: string;
  data?: Role;
};

export const handleSuccessResponse = (response: Response): Response => {
  if (response.error) {
    openToast({
      type: 'error',
      message: t('error'),
      description: response.error
    });
  } else {
    openToast({
      type: 'success',
      message: t('success'),
      description: response.message
    });
  }

  return response;
};
